import React from 'react';
import Lozenge, { ThemeAppearance } from '@atlaskit/lozenge';
import iStatus from '../../types/status/iEntityStatus';
import {
  STATUS_CATEGORY_NEW,
  STATUS_CATEGORY_IN_PROGRESS,
  STATUS_CATEGORY_FINISHED,
} from '../constants/StatusCategories';
import { FlexContainer } from '../styles/styles';
import iJobStatus from '../../types/job/iJobStatus';

const decideAppearance = (categoryName?: string): ThemeAppearance => {
  switch (categoryName) {
    case STATUS_CATEGORY_NEW:
      return 'default';
    case STATUS_CATEGORY_IN_PROGRESS:
      return 'inprogress';
    case STATUS_CATEGORY_FINISHED:
      return 'success';
    default:
      return 'default';
  }
};
const StatusLozenge = ({
  status,
  categoryCode,
  children,
}: {
  status?: iStatus | iJobStatus;
  categoryCode?: string;
  children?: React.ReactChild;
}) => {
  return (
    <Lozenge appearance={decideAppearance(categoryCode)}>
      <FlexContainer>
        <div>{status?.name}</div>
        {children}
      </FlexContainer>
    </Lozenge>
  );
};

export default StatusLozenge;
